import { type FunctionComponent } from 'react';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { Footer } from '../Layout/Footer/Footer';
import { Menu } from '../Menu/Menu';
import styles from './ErrorRecovery.module.css';

export type ErrorRecoveryProps = {
  message?: string;
};

export const ErrorRecovery: FunctionComponent<ErrorRecoveryProps> = ({
  message,
}) => {
  return (
    <div className={styles.root}>
      <Menu failSafe />
      <ErrorMessage message={message} />
      <Footer className={styles.footer} />
    </div>
  );
};
